<template>
    <b-form-group
      :label="ehObrigatorio ? 'Departamento Regional*': 'Departamento Regional'"
      label-for="departamento"
      label-class="font_size_label">
      <validation-provider #default="{ errors }" name="Departamento" :rules="rules">
        <v-select
          id="departamento"
          :options="options"
          v-model="selected"
          placeholder="Selecione o departamento"
          label="descricao"
          :clearable="false"
        >
          <span slot="no-options">Nenhuma opção selecionável.</span>
        </v-select>
        <small v-if="errors[0]" class="text-danger">
          {{ errors[0] }}
        </small>
      </validation-provider>
    </b-form-group>
</template>
  
<script>
  import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
  } from "bootstrap-vue";
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import vSelect from "vue-select";
  import { TIPO_RELATORIO_ENUM } from "../config";
  import { getUserData } from "@/auth/utils";
  
  export default {
    components: {
      BForm,
      BCol,
      BRow,
      BFormGroup,
      BFormInput,
      BButton,
      BTable,
      BSpinner,
      BFormDatepicker,
      BFormTextarea,
      BOverlay,
      ValidationProvider,
      ValidationObserver,
      vSelect,
    },
    props: {
      value: {
        required: true,
      },
      idTipoRelatorio: {
        required: true,
        type: Number
      },
      optionsConsulted: {
        required: false,
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        options: [],
        selected: this.value,
        ehObrigatorio: false,
        parametros: {
          params: {
            paginacao: false,
          },
        },
        userData: getUserData(),
        rules: "required",
        relatoriosNaoObrigatorios: [
          TIPO_RELATORIO_ENUM.NPS_ID
        ]
      };
    },
    beforeMount() {
      this.setOptions();
    },
    mounted(){
      this.ehObrigatorio = !this.relatoriosNaoObrigatorios.includes(this.idTipoRelatorio);
      this.rules = this.ehObrigatorio ? 'required' : '';
    },
    methods: {
      async setOptions() {
        if (this.optionsConsulted.length > 0) {
          this.options = this.optionsConsulted;
          return;
        }
  
        await this.$http
          .get(this.$api.departamento(), this.parametros)
          .then(({ data }) => {
            this.options = data.map((departamento) => {
              return {
                id_departamento: departamento.id_departamento,
                descricao: departamento.descricao,
                uf: departamento.uf
              };
            });
          });
      },
    },
    watch: {
      selected: function (valor) {
        this.$emit("selected", valor);
      },
      options: function (valor) {
        this.$emit("options", valor);
      },
    },
  };
  </script>
  
  